import { render, staticRenderFns } from "./synchronized_resize_heatmap.vue?vue&type=template&id=81c5309c&scoped=true&lang=pug&"
import script from "./synchronized_resize_heatmap.vue?vue&type=script&lang=js&"
export * from "./synchronized_resize_heatmap.vue?vue&type=script&lang=js&"
import style0 from "./synchronized_resize_heatmap.vue?vue&type=style&index=0&id=81c5309c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c5309c",
  null
  
)

export default component.exports